// extracted by mini-css-extract-plugin
export default {"actionBtn":"table-actions_actionBtn__Qh3XE","popoverContent":"table-actions_popoverContent__Jusq9","popoverItem":"table-actions_popoverItem__lHDOm"};